<template>
  <div>
    <Transition name="page-transition" mode="out-in" appear>
      <BackgroundAnimation :background-effects="backgroundEffects" :key="game" />
    </Transition>
    <div class="hgroup-line">
      <div class="hgroup-line_wrapper">
        <div class="about-card_select">
          <GameSwitcher :selected-game="game" @game-change="switchGame"/>
        </div>
      </div>
    </div>

    <div class="hgroup hgroup__layout">
      <h1 class="heading1">{{ $t('Карта Леста') }}</h1>
    </div>

    <Transition name="page-transition" mode="out-in" appear>
      <Component
        :is="currentAboutComponent"
        :game="game"
        :partner="partnerName"
      />
    </Transition>
  </div>
</template>

<script>
import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import { namespace, State } from 'vuex-class'

import {
  AboutCardMtByAlfa,
  AboutCardMkByAlfa,
  AboutCardTbByAlfa,

  AboutCardMtRuTbank,
  AboutCardTbRuTbank,
  AboutCardMkRuTbank
} from '@/components/AboutCard'

import GameSwitcher from '@/components/GameSwitcher/GameSwitcher'
import PartnerSwitcher from '@/components/PartnerSwitcher/PartnerSwitcher'
import BackgroundAnimation from '@/components/BackgroundAnimation/BackgroundAnimation.vue'
import {
  GAMES,
  AVAILABLE_PARTNERS,
  DEFAULT_PARTNER_FOR_COUNTRY,
  ROUTE_GAME_MAP,
  GAME_ROUTE_MAP,
  PARTNERS_TAG_TO_NAME
} from '@/constants'

const cards = namespace('cards')

const ABOUT_COMPONENTS = {
  RU: {
    mt: {
      tbank: AboutCardMtRuTbank
    },
    mk: {
      tbank: AboutCardMkRuTbank
    },
    tb: {
      tbank: AboutCardTbRuTbank
    }
  },
  BY: {
    mt: {
      alfa: AboutCardMtByAlfa
    },
    mk: {
      alfa: AboutCardMkByAlfa
    },
    tb: {
      alfa: AboutCardTbByAlfa
    }
  }
}

@Component({
  components: {
    AboutCardMtByAlfa,
    AboutCardMkByAlfa,
    AboutCardTbByAlfa,

    AboutCardMtRuTbank,
    AboutCardTbRuTbank,
    AboutCardMkRuTbank,

    GameSwitcher,
    PartnerSwitcher,
    BackgroundAnimation
  }
})
class AboutCardView extends Vue {
  @Prop({ type: String }) slug
  @Prop({ type: String }) partner
  @cards.Getter firstBoundCard
  @cards.Getter cardsByTags
  @State('country') currentCountry

  /**
   * dynamic child component name
   * @returns {String}
   */
  get currentAboutComponent () {
    if (this.partner) {
      return ABOUT_COMPONENTS[this.currentCountry][this.game][this.partner]
    }
    if (this.defaultPartnerAvailable && this.partner === undefined) {
      return null
    }
    return ABOUT_COMPONENTS[this.currentCountry][this.game]
  }

  get availablePartners () {
    return AVAILABLE_PARTNERS[this.currentCountry]
  }

  get partnerName () {
    if (!AVAILABLE_PARTNERS[this.currentCountry].includes(this.partner)) return null
    return PARTNERS_TAG_TO_NAME[this.partner] || this.partner
  }

  /**
   * Select will be able if user have some card from available partners but not from default for the country
   * @returns {boolean}
   */
  get selectPartnerAvailable () {
    const defaultPartner = DEFAULT_PARTNER_FOR_COUNTRY[this.currentCountry]
    const withoutDefault = Object.keys(this.availablePartners).reduce((acc, curr) => {
      if (curr !== defaultPartner) return [...this.availablePartners[curr]].map(i => i.tag)
      return acc
    }, [])
    return !!this.cardsByTags(withoutDefault).length
  }

  get defaultPartnerAvailable () {
    return Object.keys(DEFAULT_PARTNER_FOR_COUNTRY).includes(this.currentCountry)
  }

  get game () {
    return ROUTE_GAME_MAP[this.slug]
  }

  get backgroundEffects () {
    return [`${this.game}_spark.png`, `${this.game}_sphere.png`]
  }

  @Watch('currentCountry', { immediate: true })
  onCountryChange (val) {
    return this.redirectToDefault()
  }

  beforeRouteEnter (to, from, next) {
    next((vm) => {
      vm.slug === undefined && vm.redirectToDefault()
    })
  }

  beforeRouteUpdate (to, from, next) {
    if (to.params.slug === undefined) {
      return this.redirectToDefault()
    }

    next()
  }

  redirectToDefault () {
    const defaultGame = this.firstBoundCard && this.firstBoundCard.currentGame !== undefined
      ? this.firstBoundCard.currentGame
      : GAMES.MT // MT by default for bullet proof
    // TODO: [AB] defaultPartnerAvailable Need refactoring
    try {
      if (this.defaultPartnerAvailable) {
        if (ABOUT_COMPONENTS[this.currentCountry][this.game][this.partner]) {
          this.switchGameAndPartner(this.game, this.partner)
        } else {
          this.switchGameAndPartner(defaultGame, DEFAULT_PARTNER_FOR_COUNTRY[this.currentCountry])
        }
      } else {
        this.switchGameAndPartner(defaultGame)
      }
    } catch (e) {
      this.switchGameAndPartner(defaultGame, DEFAULT_PARTNER_FOR_COUNTRY[this.currentCountry])
    }
  }

  switchGame (game) {
    const slug = GAME_ROUTE_MAP[game]

    this.$router.push({ params: { slug } })
  }

  switchPartner (partner) {
    this.$router.push({ params: { partner } })
  }

  switchGameAndPartner (game, partner) {
    const slug = GAME_ROUTE_MAP[game]

    this.$router.push({ params: { slug: slug, partner } })
  }
}

export default AboutCardView
</script>

<style lang="scss"></style>
